import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false })

Vue.use(Vuex)

export default new Vuex.Store({
  //plugins: [createPersistedState()],
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
  state: {
    alarmas: null,
    currentlocation: '',
    disclaimer: 'Powered by Xpectra',
    currentdevice: '',
    currentUser: {
      nombre: null,
      cargo: null,
      ubicacionActual: "Ubicacion usuario",
      sucursales: [{
        IdSucursal: 0,
        Descripcion: "Ubicacion 1"
      },{
        IdSucursal: 1,
        Descripcion: "Ubicacion 2"
      }]
    },
    expire: null,
    token:null,
    habilitado: null,
    refreshTokenEveryNMin: null
  },
  mutations: {
    saveAlarms (state, value) {
      //console.log(value)
      state.alarmas = value
      //console.log(state.alarmas)
    },
    setToken(state, value){
      //console.log(value)
      state.token = value
    },
    setExpire(state, value){
      //console.log(value)
      state.expire = value
    },
    setHabilitado(state,value){
      state.habilitado = value
    },
    setCurrentUser(state,value){
      state.currentUser = value
    },
    setCurrentDevice(state,value){
      state.currentdevice = value
    },
    logout(state){
      state.currentUser = null
      state.token = null
      state.habilitado = null
      state.refreshTokenEveryNMin = null
      state.alarmas = null
    },
    setRefreshTokenEveryNMin(state,value){
      state.refreshTokenEveryNMin = value
    },
    setIpStreamingCentral(state,value){
      state.IpStreamingCentral = value
    },
    setCurrenSucursal(state,value){
      if(state.currentUser)
        state.currentUser.ubicacionActual = value

      state.ubicacionActual = value
    },
    setCurrenSucursalId(state,value){
      if(state.currentUser)
        state.currentUser.IdUbicacionActual = value

      state.IdUbicacionActual = value
    },
  },
  actions: {
    commitAlarms ({commit}, value) {
      commit('saveAlarms', value)
    },
    logout({commit}){
      commit("logout")
    },
    setCurrentDevice({commit}, value){
      commit("setCurrentDevice", value)
    },
    saveToken({commit}, value){
      commit("setToken", value.token)
      commit("setExpire", value.expire)
    },
    saveHabilitado({commit},value){
      commit("setHabilitado", value)
    },
    saveRefreshTokenEveryNMin({commit},value){
      commit("setRefreshTokenEveryNMin", value)
    },
    saveCurrentUser({commit},value){
      commit("setCurrentUser", value)
    },
    saveCurrenSucursal({commit}, value){
      try{
        commit("setCurrenSucursal", value.ubicacionActual)
        commit("setCurrenSucursalId", value.IdUbicacionActual)
      }
      catch(error){
        //console.log("Handled error: " + error);
        commit("setCurrenSucursal", null)
        commit("setCurrenSucursalId", null)
      }
    },
    saveIpStreamingCentral({commit},value){
      commit("setIpStreamingCentral", value)
    },
  },
  modules: {
  }
})
